import { Injectable         } from "@angular/core";
import { Observable         } from "rxjs";

import { ApiResponseModel   ,
         HttpApiService     } from "nv@services/http.service";


@Injectable({
  providedIn: 'root'
})
export class MapsApi extends HttpApiService {

  /**
   * @author Mihail Petrov
   * @returns
   */
  public getMapsToken(): Observable<ApiResponseModel> {

    return this.forEndpoint(`application`, `maps`, `token`)
               .fetch();
  }
}
